import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, getSynch } from "./crprgpAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk("crprgp/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const postSynch = createAsyncThunk(
  "crprgp/postSynch",
  async (payload) => {
    const response = await getSynch(payload);
    return response;
  }
);

export const crprgpSlice = createSlice({
  name: "crprgp",
  initialState,
  reducers: {
    resetData: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(postSynch.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynch.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData } = crprgpSlice.actions;

export const selectData = (state) => state.crprgp.value;
export const selectLoading = (state) => state.crprgp.loading;
export const selectError = (state) => state.crprgp.error;
export const selectPageNo = (state) => state.crprgp.pageNo;
export const selectPageSize = (state) => state.crprgp.pageSize;
export const selectTotalRecord = (state) => state.crprgp.totalRecord;

export default crprgpSlice.reducer;
